// Modal v1.3 ~ Support Ref Forward

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import AppContext from 'app/AppContext';

const theme = createTheme({
  palette: {
    type: "dark"
  }
});

export function withModal(OriginalComponent) {
    class ModalWrap extends React.Component {
        state = {
            className: "",
            busy: false,
            message: null,
            show: false,
            title: null,
            header: null,
            view: "",
            footer: null
        }

        onCloseModal = () => {
            this.setState({
                show: false,
            });
        }

        setModalMessage = (message, isBusy = false) => {
            this.setState({
                busy: isBusy,
                message: message
            });
        }

        setFree = () => {
            this.setState({
                busy: false,
                message: null
            });
        }

        setModalBusy = (busy = true) => {
            this.setState({
                busy: busy,
            });
        }
            
        overlay = () => {
            if(this.state.busy || this.state.message != null)
                return (
                    <div className="modal-overlay"
                        ref={el => {
                            if (!el) return;
                            //console.log(el.getBoundingClientRect());
                        }}>
                        {this.state.busy && AppContext.r['preloader']}

                        <div className="message">
                            {this.state.message}
                        </div>
                    </div>);

            return "";
        }

        setModalTitle = (title) => {
            this.setState({
                title: title,
            })
        }

        setModalView = (title, view, show = null, className = null, footer = null) => {
            this.setState({
                title: title,
                view: view,
                show: show ? show : this.state.show,
                className: className ? className : this.state.className,
                footer: footer
            })
        }

        confirm = (title, text, callback) => {
            this.setState({
                title: title,
                view: text,
                footer: (
                    <>
                        <Button variant="secondary" onClick={this.onCloseModal}>
                            {AppContext.r["no"]}
                        </Button>
                        
                        <Button variant="danger" onClick={() => callback()}>
                            {AppContext.r["yes"]}
                        </Button>
                    </>
                ),
                show: true
            })
        }

        show = (show = true) => {
            this.setState({
                show: show
            })
        }

        hide = () => {
            this.setState({
                show: false,
                busy: false
            })
        }

        render() {
            const newProps = {
                modal: {
                    confirm: this.confirm,
                    setMessage: this.setModalMessage,
                    setTitle: this.setModalTitle,
                    setView: this.setModalView,
                    setFree: this.setFree,
                    setBusy: this.setModalBusy,
                    show: this.show,
                    hide: this.hide,
                }
            }

            // Return original component with additional props
            return <>
                    <OriginalComponent ref={this.props.forwardedRef} {...this.props} {...newProps} />

                    <ThemeProvider theme={theme}>
                        <Modal show={this.state.show} onHide={this.onCloseModal} className={"test-theme " + this.state.className}>
                            <Modal.Header closeButton>
                                { this.state.header && this.state.header }
                                { this.state.title && <Modal.Title>{this.state.title}</Modal.Title> }
                            </Modal.Header>
                            
                            <Modal.Body>
                                {this.state.view}
                            </Modal.Body>

                            { this.state.footer &&
                                <Modal.Footer>
                                    { this.state.footer }
                                </Modal.Footer>
                            }

                            {this.overlay()}
                        </Modal>
                    </ThemeProvider>
                </>
        }
    }

    // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to Modal as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.
    return React.forwardRef((props, ref) => {
        return <ModalWrap {...props} forwardedRef={ref} />;
    });
}